import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationItem from './NotificationItem';
//import {notifications} from './data';
import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from './CustomScrollbarsNotis';
import NotybotEmptyNotification from '../../assets/images/notybot/notybot_empty_notifications.png'
import {
  getNotisByUserid,getEsignering,getMoteByID,getCurrentTodo,getAvtalByID,getpersonligaaterkomstByID,
  getArende, goToBoardById,getDashboardCompetition,setDismissThisNotisByUserid,getOrderByID, getProject
} from 'actions'
import {List} from '@mui/material';
import { withRouter } from "react-router-dom";


function mapStateToProps({auth}) {
  const { authUser,Notification} = auth;
  return {
    authUser,Notification
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNotisByUserid: (userid) => dispatch(getNotisByUserid(userid)),
    getEsignering: (Afid, userid, Esignering,fromOffert,EsigneringFrom) => dispatch(getEsignering(Afid, userid, Esignering,fromOffert,EsigneringFrom)),
    getMoteByID: (Orgrn, Afid, userid, Event) => dispatch(getMoteByID(Orgrn, Afid, userid, Event)),
    getCurrentTodo: (Afid,Userid,Todoid) => dispatch(getCurrentTodo(Afid,Userid,Todoid)),
    getAvtalByID: (Orgrn,Afid,userid,Avtal) => dispatch(getAvtalByID(Orgrn,Afid,userid,Avtal)),
    getOrderByID: (Orgrn,Afid,userid,Order) => dispatch(getOrderByID(Orgrn,Afid,userid,Order)),
    getpersonligaaterkomstByID: (Afid,userid,Id) => dispatch(getpersonligaaterkomstByID(Afid,userid,Id)),
    getArende: (ArandeId,userid, save, Afid) => dispatch(getArende(ArandeId,userid, save, Afid)),
    goToBoardById: (Afid,Userid,BoardId,CardId) => dispatch(goToBoardById(Afid,Userid,BoardId,CardId)),
		getProject: (Afid, Userid, ProjectId,ToProject, listNumber) => dispatch(getProject(Afid, Userid, ProjectId,ToProject, listNumber)),
    getDashboardCompetition: (Userid, Afid, CompId) => dispatch(getDashboardCompetition(Userid, Afid, CompId)),
    setDismissThisNotisByUserid: (userid, notis) => dispatch(setDismissThisNotisByUserid(userid, notis)),
  };
}

class AppNotification extends Component {
  state={
    
  }
  intervalID = null
  componentDidMount=()=>{
    const userid = this.props.authUser.user_id
    if(userid!==6){
   /* this.props.getNotisByUserid(userid)
    console.log("getNotisByUserid1")
    this.intervalID = setInterval(() => {
      console.log("getNotisByUserid2")
      this.props.getNotisByUserid(userid)
    }, 150000);
    */
  }
  /*else{
    this.props.getNotisByUserid(userid)
    this.intervalID = setInterval(() => {
      this.props.getNotisByUserid(userid)
    }, 60000);
  }
  */
}
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  getEsignering=(n)=>{
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    const Esigneringid = n;
    this.props.getEsignering(Afid,userid,Esigneringid,false,1)
}
getEsignerinGA=(n)=>{
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    const Esigneringid = n;
    this.props.getEsignering(Afid,userid,Esigneringid,false,2)
}
goToAktivitet=(id)=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  this.props.history.push({
      pathname: '/app/Aktiviteter'
    })
  //get Aktivitet
  this.props.getCurrentTodo(Afid, userid, id)
}
gotoEvent=(id)=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  this.props.getMoteByID("", Afid, userid, id)
}
gotoKampanj=()=>{
  this.props.history.push({
    pathname: '/app/Dialer'
  })
}
gotoAvtal=(id)=>{
  this.props.history.push({
    pathname: '/app/AvtalsKort',
    state: { AvtalId: id }
  })
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  this.props.getAvtalByID("",Afid,userid,id)
}
gotoOrder = (id)=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  this.props.getOrderByID("",Afid,userid,id)
}
gotoPersonaterkomst=(id)=>{
  const userid = this.props.authUser.user_id
  const Afid = this.props.authUser.user_Afid;
  this.props.getpersonligaaterkomstByID(Afid,userid,id)
}
gotoArande=(id)=>{
  const userid = this.props.authUser.user_id
  const Afid = this.props.authUser.user_Afid;
  this.props.getArende(id,userid, undefined, Afid)
}
gottoProjektBoard=(id, id2)=>{
  const userid = this.props.authUser.user_id
  const Afid = this.props.authUser.user_Afid;
  this.props.goToBoardById(Afid,userid,id,id2)
}
gotoProjekt=(id)=>{
  const userid = this.props.authUser.user_id
  const Afid = this.props.authUser.user_Afid;
  this.props.getProject(Afid, userid, id, 1)
}
gotoDocument=(id)=>{
  this.props.history.push({
    pathname: '/app/Dokument',
    state: { Docid: id, UtkastFlag: 0 }
  })
}
gotoDashboardcomp=(id)=>{
  const userid = this.props.authUser.user_id
  const Afid = this.props.authUser.user_Afid;
  this.props.getDashboardCompetition(userid, Afid, id)
  this.props.history.push({pathname:"/app/DashboardTavling", state: {CompId: id}})
}
dismissThisNotis=(notis) => {
  const userid = this.props.authUser.user_id
  this.props.setDismissThisNotisByUserid(userid,notis)
}
  render() {
    return (
      <>
      <CustomScrollbars className="messages-list scrollbar">
      <List style={{maxWidth:"378px",width:"100%",padding:"auto", position: 'relative'}}>
        {
          // Ändra till !== 
          this.props.Notification.length !== 0? 
          this.props.Notification.map((notification, index) => 
          { 
            return (
              <NotificationItem 
                key={index}
                getEsignering={this.getEsignering}
                getEsignerinGA={this.getEsignerinGA}
                goToAktivitet={this.goToAktivitet}
                gotoEvent={this.gotoEvent}
                gotoKampanj={this.gotoKampanj}
                gotoAvtal={this.gotoAvtal}
                gotoOrder={this.gotoOrder}
                gotoPersonaterkomst={this.gotoPersonaterkomst}
                gotoArande={this.gotoArande}
                gottoProjektBoard={this.gottoProjektBoard}
								gotoProjekt={this.gotoProjekt}
                gotoDocument={this.gotoDocument}
                gotoDashboardcomp={this.gotoDashboardcomp}
                notification={notification}
                dismissThisNotis={this.dismissThisNotis}
              />
            )
          })
          : 
          <div className="d-flex flex-column align-items-center mt-3"><img src={NotybotEmptyNotification} alt="notybot" style={{ height: '200px'}}/>
          <p>
          <IntlMessages id="Notis.Empty" />
          </p>
          </div>
        }
      </List>
    </CustomScrollbars>
    
    </>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,mapDispatchToProps
)(AppNotification));



